function BlockSettingsSidebar({ selectedBlock, selectedTypeMeta, SelectedFormComponent, onChange }) {
    if (!selectedBlock || !selectedTypeMeta || !SelectedFormComponent) {
        return (
            <aside className='edit-main-page__sidebar'>
                <div className='edit-main-page__sidebar-empty'>
                    Выберите блок слева, чтобы настроить его.
                </div>
            </aside>
        );
    }

    return (
        <aside className='edit-main-page__sidebar'>
            <div className='edit-main-page__sidebar-header'>
                <div className='edit-main-page__sidebar-title'>{selectedTypeMeta.title}</div>
            </div>
            <div className='edit-main-page__item-body'>
                <SelectedFormComponent
                    item={selectedBlock}
                    title={selectedTypeMeta.title}
                    handleChange={onChange}
                />
            </div>
        </aside>
    );
}

export default BlockSettingsSidebar;
